(function () {
  'use strict';
  var NT = window.NT || {};
  var root = NT.root || '/';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmt(cents) {
    var v = Math.round(cents) / 100;
    var s = v % 1 ? v.toFixed(2).replace('.', ',') : String(v).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return s + ' TL';
  }
  function clean(t) {
    return String(t || '').replace(/^NUTREMİN\s+/, '');
  }
  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }
  function txt(n) {
    return n.textContent.replace(/ /g, ' ').trim();
  }
  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    });
  }
  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }
  function errText(e) {
    return (e && (e.description || e.message)) || 'İşlem tamamlanamadı, lütfen tekrar deneyin.';
  }
  var TRUCK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"></path><path d="M14 10h4l3 3v3h-7"></path><circle cx="7" cy="18" r="2"></circle><circle cx="17" cy="18" r="2"></circle></svg>';

  /* ---------- Sepet cekmecesi ---------- */
  var drawer, lastFocus;

  function buildDrawer() {
    if (drawer) return;
    drawer = document.createElement('div');
    drawer.className = 'nt-drawer';
    drawer.hidden = true;
    drawer.innerHTML =
      '<div class="nt-drawer__overlay" data-nt-close></div>' +
      '<aside class="nt-drawer__panel" role="dialog" aria-modal="true" aria-label="Sepet">' +
      '<div class="nt-drawer__head"><h2>Sepetin <span data-nt-dcount></span></h2>' +
      '<button type="button" class="nt-drawer__close" data-nt-close aria-label="Sepeti kapat">&times;</button></div>' +
      '<div class="nt-drawer__ship" data-nt-dship></div>' +
      '<div class="nt-drawer__body" data-nt-dbody></div>' +
      '<div class="nt-drawer__foot" data-nt-dfoot></div></aside>';
    document.body.appendChild(drawer);
    drawer.addEventListener('click', onDrawerClick);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
  }
  function openDrawer() {
    buildDrawer();
    if (!drawer.hidden) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('nt-lock');
    drawer.querySelector('.nt-drawer__close').focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('nt-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function bubble(n) {
    var a = document.getElementById('cart-icon-bubble');
    if (!a) return;
    var b = a.querySelector('.cart-count-bubble');
    if (!n) {
      if (b) b.remove();
      return;
    }
    if (!b) {
      b = document.createElement('div');
      b.className = 'cart-count-bubble';
      a.appendChild(b);
    }
    b.innerHTML = '<span aria-hidden="true">' + n + '</span><span class="visually-hidden">' + n + ' ürün</span>';
  }
  function tierMsg(count, tiers, word) {
    if (!count || !tiers || !tiers.length) return '';
    var cur = 0, next = null;
    tiers.forEach(function (t) {
      if (count >= t[0]) cur = Math.max(cur, t[1]);
      else if (!next || t[0] < next[0]) next = t;
    });
    var s = cur ? '%' + cur + ' ' + word + ' indirimi sepetinde. ' : '';
    if (next) s += (next[0] - count) + ' ' + word + ' daha ekle, %' + next[1] + ' indirim kazan.';
    return s;
  }
  function renderCart(cart, err) {
    buildDrawer();
    var body = drawer.querySelector('[data-nt-dbody]');
    var foot = drawer.querySelector('[data-nt-dfoot]');
    var ship = drawer.querySelector('[data-nt-dship]');
    drawer.querySelector('[data-nt-dcount]').textContent = cart.item_count ? '· ' + cart.item_count + ' ürün' : '';
    bubble(cart.item_count);
    if (!cart.item_count) {
      ship.innerHTML = '';
      body.innerHTML = '<div class="nt-empty"><span>Sepetin şu an boş.</span><button type="button" class="nt-btn nt-btn--green" data-nt-close>Alışverişe başla</button></div>';
      foot.innerHTML = '';
      return;
    }
    var goal = +NT.freeShip || 0;
    var rem = goal - cart.total_price;
    if (goal) {
      var pct = Math.max(4, Math.min(100, Math.round((cart.total_price / goal) * 100)));
      ship.innerHTML = '<div class="nt-ship__top"><span>' + TRUCK + (rem > 0 ? 'Ücretsiz kargoya ' + fmt(rem) + ' kaldı' : 'Kargon bedava') + '</span>' +
        '<small>' + fmt(cart.total_price).replace(' TL', '') + ' / ' + fmt(goal) + '</small></div>' +
        '<div class="nt-ship__bar"><i style="width:' + pct + '%"></i></div>';
    } else {
      ship.innerHTML = '';
    }
    var h = '';
    if (NT.live) {
      var vin = NT.vinIds || [], herbs = 0, vins = 0;
      var skip = [NT.mix && NT.mix.id, NT.set && NT.set.id];
      cart.items.forEach(function (it) {
        if (vin.indexOf(it.product_id) > -1) vins += it.quantity;
        else if (skip.indexOf(it.product_id) < 0) herbs += it.quantity;
      });
      var m1 = tierMsg(herbs, NT.herb, 'bitki'), m2 = tierMsg(vins, NT.vin, 'sirke');
      if (m1) h += '<div class="nt-tier">' + esc(m1) + '</div>';
      if (m2) h += '<div class="nt-tier">' + esc(m2) + '</div>';
    }
    if (err) h += '<p class="nt-drawer__err" role="alert">' + esc(err) + '</p>';
    h += '<div class="nt-items">';
    cart.items.forEach(function (it, i) {
      var t = clean(it.product_title);
      var sub = (it.line_level_discount_allocations || []).map(function (a) {
        return a.discount_application && a.discount_application.title;
      }).filter(Boolean).join(', ');
      var isSet = NT.set && NT.set.id === it.product_id;
      if (isSet) t = NT.set.title || t;
      if (!sub && isSet) sub = NT.set.sub || '';
      h += '<div class="nt-item">' +
        '<a class="nt-item__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="nt-item__mid"><a class="nt-item__title" href="' + esc(it.url) + '">' + esc(t) + '</a>' +
        (sub ? '<span class="nt-item__sub">' + esc(sub) + '</span>' : '') +
        '<div class="nt-item__row"><div class="nt-qty nt-qty--s"><button type="button" data-nt-line="' + (i + 1) + '" data-nt-q="' + (it.quantity - 1) + '" aria-label="' + esc(t) + ' adedini azalt">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-nt-line="' + (i + 1) + '" data-nt-q="' + (it.quantity + 1) + '" aria-label="' + esc(t) + ' adedini artır">+</button></div>' +
        '<span class="nt-item__pr"><b>' + fmt(it.final_line_price) + '</b>' +
        (it.original_line_price > it.final_line_price ? '<s>' + fmt(it.original_line_price) + '</s>' : '') + '</span></div></div></div>';
    });
    h += '</div>';
    if (goal && rem > 0 && NT.upsell && NT.upsell.length) {
      var inCart = cart.items.map(function (it) { return it.variant_id; });
      var ups = NT.upsell.filter(function (u) { return inCart.indexOf(u.id) < 0; }).slice(0, 2);
      if (ups.length) {
        h += '<div class="nt-up"><h4>Kargoyu bedavaya getir</h4>';
        ups.forEach(function (u) {
          h += '<div class="nt-up__row">' + (u.img ? '<img src="' + esc(u.img) + '" alt="" width="56" height="56" loading="lazy">' : '') +
            '<span>' + esc(u.title) + '<small>' + fmt(u.price) + (u.price >= rem ? ' · kargo bedava olur' : '') + '</small></span>' +
            '<button type="button" class="nt-chip" data-nt-upsell="' + u.id + '" aria-label="' + esc(u.title) + ' sepete ekle">Ekle</button></div>';
        });
        h += '</div>';
      }
    }
    body.innerHTML = h;
    var f = '<div class="nt-sum"><span>Ara toplam</span><span>' + fmt(cart.original_total_price) + '</span></div>';
    if (cart.total_discount > 0) f += '<div class="nt-sum nt-sum--disc"><span>Paket indirimi</span><span>−' + fmt(cart.total_discount) + '</span></div>';
    f += '<div class="nt-sum"><span>Kargo</span><span>' + (goal && rem <= 0 ? 'Ücretsiz' : 'Ödemede hesaplanır') + '</span></div>' +
      '<div class="nt-sum nt-sum--total"><span>Toplam</span><span>' + fmt(cart.total_price) + '</span></div>' +
      '<a class="nt-btn nt-btn--wine" href="' + root + 'checkout">Ödemeye geç</a>' +
      '<button type="button" class="nt-drawer__cont" data-nt-close>Alışverişe devam et</button>';
    foot.innerHTML = f;
  }
  function busy(on) {
    if (drawer) drawer.classList.toggle('is-busy', !!on);
  }
  function refresh(err) {
    return getCart().then(function (c) {
      renderCart(c, err);
      return c;
    });
  }
  function addItems(items) {
    return post('cart/add.js', { items: items }).then(function () {
      return refresh();
    }).then(function (c) {
      openDrawer();
      return c;
    });
  }
  function onDrawerClick(e) {
    var t = e.target;
    if (t.closest('[data-nt-close]')) {
      closeDrawer();
      return;
    }
    var q = t.closest('[data-nt-line]');
    if (q) {
      busy(true);
      post('cart/change.js', { line: +q.getAttribute('data-nt-line'), quantity: Math.max(0, +q.getAttribute('data-nt-q')) })
        .then(function (c) { renderCart(c); })
        .catch(function (er) { return refresh(errText(er)); })
        .then(function () { busy(false); });
      return;
    }
    var u = t.closest('[data-nt-upsell]');
    if (u) {
      busy(true);
      post('cart/add.js', { items: [{ id: +u.getAttribute('data-nt-upsell'), quantity: 1 }] })
        .then(function () { return refresh(); })
        .catch(function (er) { return refresh(errText(er)); })
        .then(function () { busy(false); });
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!a) return;
    e.preventDefault();
    refresh().then(openDrawer);
  });

  /* Sitedeki tum sepete ekle formlari cekmeceyi acar (ana sayfa, koleksiyon, arama) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    if ((f.getAttribute('action') || '').indexOf('/cart/add') < 0) return;
    var id = f.querySelector('[name="id"]');
    if (!id || !id.value) return;
    e.preventDefault();
    e.stopPropagation();
    var qEl = f.querySelector('[name="quantity"]');
    var qty = qEl ? Math.max(1, parseInt(qEl.value, 10) || 1) : 1;
    var b = f.querySelector('[type="submit"]');
    var old = f.querySelector('.nt-pdp__msg');
    if (old) old.remove();
    if (b) b.disabled = true;
    addItems([{ id: +id.value, quantity: qty }]).catch(function (er) {
      var p = document.createElement('p');
      p.className = 'nt-pdp__msg';
      p.setAttribute('role', 'alert');
      p.textContent = errText(er);
      f.appendChild(p);
    }).then(function () {
      if (b) b.disabled = false;
    });
  }, true);

  /* Urun aciklamasini toparla: bos satirlar, tekrar eden baslik, ara basliklar */
  function tidyDesc() {
    each(document.querySelectorAll('[data-nt-desc]'), function (b) {
      each(b.querySelectorAll('p,div,h1,h2,h3,h4,li'), function (n) {
        if (!txt(n) && !n.querySelector('img,iframe,video')) n.remove();
      });
      var f = b.firstElementChild;
      if (f && b.children.length > 1) {
        var st = f.querySelector('strong,b');
        var only = st && txt(st) === txt(f);
        if ((/^H[1-4]$/.test(f.tagName) || only) && txt(f).length < 90) f.remove();
      }
      each(b.querySelectorAll('p,div,h1,h2,h3,h4'), function (n) {
        if (n.closest('li')) return;
        var s = n.querySelector('strong,b');
        if (/^H[1-4]$/.test(n.tagName) || (s && txt(s) === txt(n))) n.classList.add('nt-acc__h');
      });
    });
  }

  /* ---------- Urun sayfasi: Paketini sec ---------- */
  function initPdp() {
    tidyDesc();
    var el = document.querySelector('[data-nt-pdp]');
    var src = document.getElementById('nt-pdp-data');
    if (!el || !src) return;
    var d;
    try { d = JSON.parse(src.textContent); } catch (e) { return; }
    var live = !!NT.live, set = NT.set, vinIds = NT.vinIds || [];
    var isVin = vinIds.indexOf(d.id) > -1;
    var isMix = !!(NT.mix && NT.mix.id === d.id);
    var isSet = !!(set && set.id === d.id);
    var inSet = !!(set && set.available && (set.components || []).indexOf(d.id) > -1);
    var isHerb = !isVin && !isMix && !isSet;
    var unit = isVin || isMix ? 'Şişe' : 'Paket';
    var packs = [], st = { sel: 'one', qty: 1, picks: [], mix: false };
    var herbT = (NT.herb || [])[0];
    var trioN = herbT ? +herbT[0] : 0;
    var trioP = live && herbT ? +herbT[1] : 0;
    var ban = vinIds.concat([NT.mix && NT.mix.id, set && set.id]);
    var opts = isVin
      ? (NT.vinList || []).filter(function (x) { return x.id !== d.variantId; })
      : (d.sugg || []).filter(function (s) { return ban.indexOf(s.pid) < 0; });
    var maxQ = 1;

    if (!isSet) {
      packs.push({ k: 'one', q: 1, pct: 0, label: isHerb ? 'Tek paket' : '1 ' + unit, sub: d.title, price: d.price, old: d.compare > d.price ? d.compare : 0 });
      if (inSet) packs.push({ k: 'set', label: set.title, sub: set.sub || '', badge: 'En çok tercih edilen', price: set.price, old: set.sum > set.price ? set.sum : 0 });
      var tiers = isVin ? (NT.vin || []) : isMix ? [[NT.mix.q, NT.mix.p]] : [];
      tiers.forEach(function (t, i) {
        var q = +t[0], pct = live ? +t[1] : 0;
        if (!(q > 1)) return;
        maxQ = Math.max(maxQ, q);
        var full = d.price * q, pr = Math.round(full * (100 - pct) / 100);
        packs.push({
          k: 'q' + q, q: q, pct: pct, label: q + ' ' + unit,
          sub: pct ? unit + ' başı ' + fmt(pr / q) + ' · %' + pct + ' indirim' : q + ' × ' + d.title,
          badge: isVin ? (i ? 'En avantajlı' : 'Popüler') : '', price: pr, old: pct ? full : 0
        });
      });
      if (isHerb && trioN > 1 && opts.length >= trioN - 1) {
        packs.push({ k: 'trio', label: d.kitchen ? 'Mutfak üçlüsü' : 'Çay üçlüsü', sub: trioN + ' bitki seç, tek pakette gelsin', badge: trioP ? trioN + ' al, %' + trioP + ' kazan' : '' });
      }
      if (isMix && inSet) st.sel = 'set';
    }
    var canMix = isVin && maxQ > 1 && opts.length > 0;

    var box = el.querySelector('[data-nt-packs]');
    var elP = el.querySelector('[data-nt-price]');
    var elO = el.querySelector('[data-nt-old]');
    var elS = el.querySelector('[data-nt-save]');
    var btns = el.querySelectorAll('[data-nt-add]');
    var buy = el.querySelector('[data-nt-buynow]');
    var qtyBoxes = el.querySelectorAll('[data-nt-qtybox]');
    var qtyEls = el.querySelectorAll('[data-nt-qty]');
    var msg = el.querySelector('[data-nt-msg]');
    var main = el.querySelector('[data-nt-main]');
    var main0 = main ? { src: main.getAttribute('src'), srcset: main.getAttribute('srcset') } : null;
    if (!box || !btns.length) return;

    function selPack() {
      return packs.filter(function (x) { return x.k === st.sel; })[0] || packs[0];
    }
    function mixing(p) {
      return canMix && st.mix && p && p.q > 1;
    }
    function slotCount(p) {
      return p && p.k === 'trio' ? trioN : mixing(p) ? p.q : 0;
    }
    function cur() {
      var p = selPack();
      if (!p) return { price: d.price * st.qty, old: d.compare > d.price ? d.compare * st.qty : 0, items: [{ id: d.variantId, quantity: st.qty }], ready: true };
      var sum, items;
      if (p.k === 'trio') {
        var need = trioN - 1 - st.picks.length;
        sum = d.price;
        items = [{ id: d.variantId, quantity: 1 }];
        st.picks.forEach(function (i) {
          sum += opts[i].price;
          items.push({ id: opts[i].id, quantity: 1 });
        });
        return { price: Math.round(sum * (100 - trioP) / 100), old: trioP && need <= 0 ? sum : 0, items: items, ready: need <= 0, need: need };
      }
      if (mixing(p)) {
        var own = p.q - st.picks.length;
        sum = d.price * own;
        items = [{ id: d.variantId, quantity: own }];
        st.picks.forEach(function (i) {
          sum += opts[i].price;
          items.push({ id: opts[i].id, quantity: 1 });
        });
        return { price: Math.round(sum * (100 - p.pct) / 100), old: p.pct ? sum : 0, items: items, ready: true };
      }
      if (p.k === 'set') return { price: p.price * st.qty, old: p.old * st.qty, items: [{ id: set.variantId, quantity: st.qty }], ready: true, gain: true };
      return { price: p.price * st.qty, old: p.old * st.qty, items: [{ id: d.variantId, quantity: p.q * st.qty }], ready: true };
    }
    function setBtns(disabled, label) {
      each(btns, function (b) {
        b.disabled = disabled;
        if (label != null) b.textContent = label;
      });
      if (buy) buy.disabled = disabled;
    }
    function slot(img, title, price, on, ok) {
      return '<div class="nt-slot' + (on ? ' nt-slot--on' : '') + '">' +
        (ok ? '<span class="nt-slot__ok" aria-hidden="true">✓</span>' : '') +
        '<span class="nt-slot__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span>' + esc(title) + '</span>' + (price ? '<small>' + fmt(price) + '</small>' : '') + '</div>';
    }
    function builder(n, fill) {
      var h = '<div class="nt-trio"><div class="nt-trio__head"><span>' + (isVin ? 'Şişelerini seç' : 'Üçlünü tamamla') + '</span><span>' +
        (fill ? n : st.picks.length + 1) + ' / ' + n + ' seçildi</span></div>' +
        '<div class="nt-trio__slots" style="grid-template-columns:repeat(' + Math.min(n, 3) + ',minmax(0,1fr))">' + slot(d.img, d.title, d.price, true, true);
      for (var i = 0; i < n - 1; i++) {
        var pk = st.picks[i];
        h += pk != null ? slot(opts[pk].img, opts[pk].title, opts[pk].price, true, true)
          : fill ? slot(d.img, d.title, d.price, true, true) : slot('', 'Seç', 0, false, false);
      }
      h += '</div><span class="nt-trio__hint">' + (isVin ? 'Farklı sirke ekle:' : 'Önerilenler:') + '</span><div class="nt-chips">';
      opts.forEach(function (s, j) {
        var on = st.picks.indexOf(j) > -1;
        h += '<button type="button" class="nt-chip" data-nt-sugg="' + j + '" aria-pressed="' + on + '">' + (on ? '✓ ' : '+ ') + esc(s.title) + '</button>';
      });
      return h + '</div></div>';
    }

    function draw(focusSel) {
      var h = '', p = selPack();
      if (packs.length > 1) {
        var hint = isVin ? (live ? 'Çok alana ek indirim' : '') : isHerb && trioP ? trioN + ' bitki seçene %' + trioP : '';
        h += '<div class="nt-packs__head"><span>' + (isVin ? 'Kaç şişe?' : 'Paketini seç') + '</span>' + (hint ? '<span>' + esc(hint) + '</span>' : '') + '</div>';
        packs.forEach(function (x) {
          h += '<button type="button" class="nt-pack" data-nt-pack="' + x.k + '" aria-pressed="' + (x.k === st.sel) + '">' +
            '<span class="nt-pack__dot"></span><span class="nt-pack__txt"><b>' + esc(x.label) + '</b><small>' + esc(x.sub) + '</small></span>' +
            (x.badge ? '<span class="nt-pack__badge">' + esc(x.badge) + '</span>' : '') +
            (x.price ? '<span class="nt-pack__pr"><b>' + fmt(x.price) + '</b>' + (x.old ? '<s>' + fmt(x.old) + '</s>' : '') + '</span>' : '') +
            '</button>';
        });
        if (p.k === 'trio') h += builder(trioN, false);
        if (canMix) {
          var on = mixing(p);
          h += '<div class="nt-mixbar"><b>Karıştır:</b><span>' + (p.q > 1 ? p.q : maxQ) + ' şişeyi farklı sirkelerden seçebilirsin.</span>' +
            '<button type="button" data-nt-mix aria-pressed="' + on + '">' + (on ? 'Aynı sirkeden al' : p.q > 1 ? 'Karışık seç' : maxQ === 3 ? 'Sirke üçlüsü oluştur' : 'Karışık paket oluştur') + '</button></div>';
          if (on) h += builder(p.q, true);
        }
      }
      box.innerHTML = h;
      var c = cur(), custom = slotCount(p) > 0;
      elP.textContent = fmt(c.price);
      elO.textContent = c.old > c.price ? fmt(c.old) : '';
      elS.textContent = c.old > c.price ? (c.gain ? fmt(c.old - c.price) + ' avantaj' : '%' + Math.round((c.old - c.price) / c.old * 100) + ' indirim') : '';
      each(qtyEls, function (q) { q.textContent = st.qty; });
      each(qtyBoxes, function (q) { q.hidden = custom; });
      setBtns(!d.available || !c.ready, !d.available ? 'Tükendi' : c.ready ? 'Sepete Ekle · ' + fmt(c.price) : c.need + ' ürün daha seç');
      if (main && main0) {
        if (p && p.k === 'set' && set.img) {
          main.removeAttribute('srcset');
          main.src = set.img;
        } else if (main.getAttribute('data-nt-swapped') !== '1') {
          if (main.getAttribute('src') === set_img()) {
            main.src = main0.src;
            if (main0.srcset) main.setAttribute('srcset', main0.srcset);
          }
        }
      }
      if (focusSel) {
        var fe = box.querySelector(focusSel);
        if (fe) fe.focus();
      }
    }
    function set_img() {
      return set && set.img ? set.img : '';
    }
    function fail(er) {
      if (!msg) return;
      msg.textContent = errText(er);
      msg.hidden = false;
    }

    el.addEventListener('click', function (e) {
      var t = e.target, x;
      if ((x = t.closest('[data-nt-pack]'))) {
        st.sel = x.getAttribute('data-nt-pack');
        var np = selPack(), n = slotCount(np);
        if (n) st.qty = 1;
        st.picks = st.picks.slice(0, Math.max(0, (n || (np.k === 'trio' ? trioN : np.q || 1)) - 1));
        draw('[data-nt-pack="' + st.sel + '"]');
      } else if (t.closest('[data-nt-mix]')) {
        var p = selPack();
        if (p.q > 1) st.mix = !st.mix;
        else {
          st.sel = 'q' + maxQ;
          st.mix = true;
        }
        st.picks = [];
        st.qty = 1;
        draw('[data-nt-mix]');
      } else if ((x = t.closest('[data-nt-sugg]'))) {
        var j = +x.getAttribute('data-nt-sugg'), at = st.picks.indexOf(j), max = slotCount(selPack()) - 1;
        if (at > -1) st.picks.splice(at, 1);
        else if (st.picks.length < max) st.picks.push(j);
        draw('[data-nt-sugg="' + j + '"]');
      } else if (t.closest('[data-nt-inc]')) {
        st.qty++;
        draw();
      } else if (t.closest('[data-nt-dec]')) {
        st.qty = Math.max(1, st.qty - 1);
        draw();
      } else if ((x = t.closest('[data-nt-thumb]'))) {
        if (main) {
          main.removeAttribute('srcset');
          main.src = x.getAttribute('data-nt-thumb');
          main0 = { src: main.src, srcset: '' };
        }
        each(el.querySelectorAll('[data-nt-thumb]'), function (b) { b.setAttribute('aria-current', b === x); });
      } else if (t.closest('[data-nt-add]') || t.closest('[data-nt-buynow]')) {
        var go = !!t.closest('[data-nt-buynow]');
        var c = cur();
        if (!c.ready || !d.available) return;
        if (msg) msg.hidden = true;
        setBtns(true);
        if (go) {
          post('cart/add.js', { items: c.items }).then(function () {
            window.location.href = root + 'checkout';
          }).catch(function (er) {
            fail(er);
            draw();
          });
        } else {
          addItems(c.items).catch(fail).then(function () { draw(); });
        }
      }
    });
    draw();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPdp);
  else initPdp();
})();
